export default "__VITE_ASSET__BHSUsRf9__"